import { render, staticRenderFns } from "./dataOverview.vue?vue&type=template&id=41fb2fd2&scoped=true"
import script from "./dataOverview.vue?vue&type=script&lang=js"
export * from "./dataOverview.vue?vue&type=script&lang=js"
import style0 from "./dataOverview.vue?vue&type=style&index=0&id=41fb2fd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb2fd2",
  null
  
)

export default component.exports